import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { useHistory, useParams } from 'react-router-dom'
import { getMultimediaById, postMultimedia, updateMultimedia } from '../../../../api/multimedia'
import { uploadSingleFile } from '../../../../api/files'
import { alertError, alertSuccess } from '../../../../utils/logger'

export default function EditMultimediaPage () {
  const { id } = useParams()
  const history = useHistory()
  const [form, setForm] = useState({
    key: 'portada',
    type: 'image',
    imageUrl: '',
    imageUrlMobile: '',
    videoUrl: '',
    posterUrl: '',
    posterUrlMobile: ''
  })

  useEffect(() => {
    if (!id) return
    getMultimediaById(id)
      .then((res) => {
        if (res.status === 200) {
          setForm({
            key: res.data.key || 'portada',
            type: res.data.type || 'image',
            imageUrl: res.data.imageUrl || '',
            imageUrlMobile: res.data.imageUrlMobile || '',
            videoUrl: res.data.videoUrl || '',
            posterUrl: res.data.posterUrl || '',
            posterUrlMobile: res.data.posterUrlMobile || ''
          })
        }
      })
      .catch(error => {
        alertError({ error, customMessage: 'No se pudo cargar el elemento.' })
      })
  }, [id])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleFileUpload = async (file, field) => {
    if (!file) return
    try {
      const folder = field === 'videoUrl' ? 'videos' : 'images'
      const response = await uploadSingleFile(file, folder)
      const url = response.data?.fileURL || response.data?.url || response.data?.path
      if (!url) throw new Error('No URL returned from upload')
      setForm(prev => ({ ...prev, [field]: url }))
      alertSuccess({ customMessage: 'Archivo subido correctamente.' })
    } catch (uploadError) {
      console.warn('Upload failed, falling back to base64 for compatibility:', uploadError)
      const reader = new FileReader()
      const base64 = await new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
      setForm(prev => ({ ...prev, [field]: base64 }))
      alertSuccess({ customMessage: 'Archivo cargado en memoria (base64). Si el vídeo es pesado, sube el MP4 al servidor y usa la ruta en "URL Vídeo".' })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (id) {
        await updateMultimedia(id, form)
        alertSuccess({ customMessage: 'Multimedia actualizada correctamente.' })
      } else {
        await postMultimedia(form)
        alertSuccess({ customMessage: 'Multimedia creada correctamente.' })
      }
      history.push('/multimedia')
    } catch (error) {
      alertError({ error, customMessage: 'No se pudo guardar el elemento.' })
    }
  }

  return (
    <Card>
      <CardHeader title={id ? 'Editar multimedia' : 'Nueva multimedia'} />
      <CardBody>
        <form className='form' onSubmit={handleSubmit}>
          <div className='form-group row'>
            <label className='col-2 col-form-label'>Clave</label>
            <div className='col-10'>
              <input
                type='text'
                name='key'
                className='form-control'
                value={form.key}
                onChange={handleChange}
                placeholder='portada'
              />
              <small className='form-text text-muted'>
                Para la portada principal usa la clave <strong>portada</strong>.
              </small>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-2 col-form-label'>Tipo</label>
            <div className='col-10'>
              <select
                name='type'
                className='form-control'
                value={form.type}
                onChange={handleChange}
              >
                <option value='image'>Imagen</option>
                <option value='video'>Vídeo</option>
              </select>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-2 col-form-label'>URL Imagen</label>
            <div className='col-10'>
              <input
                type='text'
                name='imageUrl'
                className='form-control'
                value={form.imageUrl}
                onChange={handleChange}
                placeholder='/uploads/portada.jpg'
              />
              <input
                type='file'
                accept='image/*'
                className='form-control mt-2'
                onChange={(e) => handleFileUpload(e.target.files[0], 'imageUrl')}
              />
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-2 col-form-label'>Poster (imagen para vídeo)</label>
            <div className='col-10'>
              <input
                type='text'
                name='posterUrl'
                className='form-control'
                value={form.posterUrl}
                onChange={handleChange}
                placeholder='/uploads/images/hero-poster.webp'
              />
              <input
                type='file'
                accept='image/*'
                className='form-control mt-2'
                onChange={(e) => handleFileUpload(e.target.files[0], 'posterUrl')}
              />
              <small className='form-text text-muted'>
                Si el tipo es <strong>vídeo</strong>, esta imagen se muestra primero (mejora LCP) y luego entra el vídeo.
              </small>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-2 col-form-label'>Poster móvil</label>
            <div className='col-10'>
              <input
                type='text'
                name='posterUrlMobile'
                className='form-control'
                value={form.posterUrlMobile}
                onChange={handleChange}
                placeholder='/uploads/hero-poster-mobile.webp'
              />
              <input
                type='file'
                accept='image/*'
                className='form-control mt-2'
                onChange={(e) => handleFileUpload(e.target.files[0], 'posterUrlMobile')}
              />
              <small className='form-text text-muted'>
                Versión del poster para móvil (imagen que sale antes del vídeo en pantallas pequeñas). Si está vacía, se usa el poster de escritorio.
              </small>
            </div>
          </div>

          <div className='form-group row'>
            <label className='col-2 col-form-label'>URL Vídeo</label>
            <div className='col-10'>
              <input
                type='text'
                name='videoUrl'
                className='form-control'
                value={form.videoUrl}
                onChange={handleChange}
                placeholder='https://...'
              />
              <input
                type='file'
                accept='video/mp4,video/webm,video/ogg'
                className='form-control mt-2'
                onChange={(e) => handleFileUpload(e.target.files[0], 'videoUrl')}
              />
              <small className='form-text text-muted'>
                Para evitar problemas con YouTube, sube aquí un archivo de vídeo (por ejemplo MP4)
                y se usará directamente como fondo.
              </small>
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-12 text-right'>
              <button type='submit' className='btn btn-primary mr-2'>
                Guardar
              </button>
              <button
                type='button'
                className='btn btn-secondary'
                onClick={() => history.push('/multimedia')}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      </CardBody>
    </Card>
  )
}


